export default [
  { label: 'SeasonName', key: 'seasonName' },
  { label: 'USBCMembershipId', key: 'usbcMembershipId' },
  { label: 'PlayerId', key: 'playerId' },
  { label: 'Bowler', key: 'bowler' },
  { label: 'School', key: 'school' },
  { label: 'SeasonsBowled', key: 'seasonsBowled' }
]


// WEBPACK FOOTER //
// ./src/components/pages/Report/constants/seasonsBowledHeaders.js